module.exports = __webpack_public_path__ + "img/course-7.b6f1085a.png";